import 'core-js/features/object/assign';
import 'core-js/features/object/entries';
import 'core-js/features/object/values';
import 'core-js/features/number/parse-int';
import 'core-js/features/string/includes';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/array/from';
import 'core-js/features/string/starts-with';
import 'core-js/features/url-search-params';
import 'whatwg-fetch';
import { ResizeObserver } from '@juggle/resize-observer';

window.ResizeObserver = ResizeObserver;

require('intersection-observer');

require('@formatjs/intl-getcanonicallocales/polyfill');
require('@formatjs/intl-locale/polyfill');
require('@formatjs/intl-pluralrules/polyfill');
require('@formatjs/intl-pluralrules/locale-data/en');
require('@formatjs/intl-relativetimeformat/polyfill');
require('@formatjs/intl-relativetimeformat/locale-data/en');
